<body>
    <main id="wrapper">
        <header>
            <div class="container-fluid">
                <div class="navWrap">
                    <div class="linksWrap">
                        <div class="logo">
                            <a href="index.html"><img src="./assets/images/logo.png" alt="Bajaj Life"
                                    title="Bajaj Life" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <section class="position-relative emandate">
            <div class="leftSide">
                <!--Steps for Mobile View-->
                <div class="progress-container disp-mobile">
                    <div class="progress" id="progress"></div>
                    <div class="text-wrap active">
                        <div class="content">
                            <p class="heading">Search details</p>
                            <p class="text">Let us know your <br>details</p>
                        </div>
                        <div class="stepCount">1</div>
                    </div>
                    <div class="text-wrap">
                        <div class="content">
                            <p class="heading">Policy details</p>
                            <p class="text">Provide a few more details<br> to proceed</p>
                        </div>
                        <div class="stepCount disabled">2</div>
                    </div>
                    <div class="text-wrap">
                        <div class="content">
                            <p class="heading">Register online mandate</p>
                            <p class="text">Set the mode of transaction for online mandate registration</p>
                        </div>
                        <div class="stepCount disabled">3</div>
                    </div>
                </div>
                <!--Mobile View steps End-->
            </div>
            <div class="rightSide">
                <h2>AUTOPAY MANDATE REGISTRATION</h2>
                <div class="accordion" id="accordionExample">

                    <!--Primary Details-->
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button " type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                #closeaccordian1>
                                <img src="./assets/images/001-search.png" class="img-fluid">&nbsp;&nbsp; Search details
                            </button>
                        </h2>
                        <!--Desktop step-1-->
                        <div class="stepCountRow disp-desktop">
                            <div class="content">
                                <p class="heading">Search details</p>
                                <p class="text">Let us know your details</p>
                            </div>
                            <p class="stepCount">1</p>
                        </div>
                        <!--End-->
                        <div class="accordion-collapse collapse show" id="collapseOne">
                            <div class="accordion-body" *ngIf="showAccodian1">
                                <form
                                    (ngSubmit)="g.form.valid && submitFormData(template,template1,template2,template3)"
                                    #g="ngForm">

                                    <div class="formGroup" style="row-gap: 40px;">

                                        <div class="mb-4 width position-relative">
                                            <label for="applicationOrPolicyno" class="form-label">Application
                                                Number/Policy Number</label>
                                            <input name="applicationOrPolicyno" class="form-control" type="text"
                                                class="form-control" id="applicationOrPolicyno"
                                                placeholder="Enter Application Number"
                                                [(ngModel)]="dataProvided.applicationOrPolicyno"
                                                #applicationOrPolicyno="ngModel"
                                                [ngClass]="{ 'is-invalid': g.submitted && applicationOrPolicyno.invalid }"
                                                (keyup)="checkAppNoPattern($event)" (blur)="padApplicationOrPolicyNo()"
                                                required [maxlength]="applicationOrPolicynoMaxLength">
                                            <i class="fa fa-pencil-square-o"></i>
                                            <div *ngIf="applicationOrPolicyno.invalid" class="invalid-feedback">
                                                <div *ngIf="applicationOrPolicyno.touched && applicationOrPolicyno.errors?.required"
                                                    class="showerror">
                                                    Please enter Application/Policy number</div>
                                            </div>
                                            <div *ngIf="isError" class="showerror">{{errorMessage}}</div>
                                            <!-- <span class="errorMsg">Please Enter Valid Number</span> -->
                                        </div>

                                        <div class="mb-4 width position-relative date">
                                            <label for="dateID2" class="form-label">Date of Birth of Life Assured</label>
                                            <input name="dateOfBirth" class="form-control" bsDatepicker
                                                class="form-control datepicker" id="dateID2" placeholder="DD/MM/YYYY"
                                                #dateOfBirth="ngModel" [(ngModel)]="dataProvided.dateOfBirth"
                                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', isAnimated: true }"
                                                [ngClass]="{ 'is-invalid': g.submitted && dateOfBirth.invalid }"
                                                [outsideClick]="true" [required]="isDOBRequired">
                                            <span class="bgImg"></span>
                                        </div>

                                    </div>
                                    <div class="formGroup mt-3">
                                        <p class="note">If you do not have Application/Policy Number, <a href="#"
                                                data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                (click)="getUniqueId()">Click
                                                here</a></p>
                                    </div>
                                    <div class="formGroup my-5">
                                        <button type="submit" class="btn btn-orange">Proceed</button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div><!--Accordion Item-->

                    <!--Policy Details-->
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <img src="./assets/images/002-contract.png" class="img-fluid">&nbsp;&nbsp; Policy
                                details
                            </button>
                        </h2>
                        <!--Desktop step-2-->
                        <div class="stepCountRow disp-desktop">
                            <div class="content">
                                <p class="heading">Policy details</p>
                                <p class="text">Provide a few more details to proceed</p>
                            </div>
                            <p class="stepCount disabled">2</p>
                        </div>
                        <!-- End -->
                        <div id="collapseTwo" class="accordion-collapse collapse" #collapseTwo>
                            <div class="accordion-body" *ngIf="showAccodian2">
                                <!--new change-->
                                <div class="refNo">
                                    <p>Consumer Reference No:<span>{{displayNum}}</span>&nbsp;
                                        <button class="copy-btn" (click)="copyToClipboard(displayNum)">
                                            <i class="fa fa-copy"></i>
                                        </button>
                                    </p>
                                    <p>(Policy No/Application No/Unique Code)</p>
                                </div>
                                <!--new change-->
                                <form>
                                    <div class="formGroup">
                                        <div class="mb-4 width position-relative">
                                            <label for="PolicyHolder" class="form-label">Policy Holder Name</label>

                                            <input readonly name="PolicyHolder"
                                                [(ngModel)]=" (this.isstatus === 'newCustomer' && this.isPolicy !='NGIN' && this.userdata && this.fromInstab != 'TRUE') ? this.userdata.stringval7:(this.isstatus === 'newCustomer' && this.isPolicy ==='NGIN' && this.userdata && this.fromInstab != 'TRUE') ? this.userdata.stringval1 :(this.isstatus === 'existingCustomer' && this.userdata) ? this.userdata[0].policy_holder_name : ( this.isstatus === 'newCustomer' && this.fromInstab === 'TRUE' ) ? this.instabFormData.PolicyHolderModal : this.dummydata "
                                                #premiumAmount="ngModel" type="text" class="form-control"
                                                placeholder="Policy Holder" required>
                                        </div>
                                        <!--New change-->
                                        <div class="mb-4 width position-relative date">
                                            <label for="dateID1" class="form-label">Date of Birth of Life Assured</label>


                                            <input readonly name="DoB"
                                                [(ngModel)]=" (this.isstatus === 'newCustomer' && this.isPolicy !='NGIN' && this.userdata && this.fromInstab != 'TRUE') ? this.userdata.stringval2:(this.isstatus === 'newCustomer' && this.isPolicy ==='NGIN' && this.userdata) ? this.userdata.stringval2 :(this.isstatus === 'existingCustomer' && this.userdata) ? this.userdata[0]?.dob : ( this.isstatus === 'newCustomer' && this.fromInstab === 'TRUE' && this.userdata) ? this.userdata.stringval2 : this.dummydata "
                                                #dob="ngModel" type="text" class="form-control"
                                                placeholder="Policy Holder" required>
                                            <span class="bgImg"></span>
                                        </div>
                                        <!--New change-->
                                        <div class="mb-4 width position-relative">
                                            <label for="Frequency" class="form-label">Frequency</label>


                                            <input readonly name="Frequency"
                                                [(ngModel)]="(this.isstatus === 'newCustomer' && this.userdata) ? this.userdata.stringval6:(this.isstatus === 'existingCustomer' && this.userdata) ? this.userdata[0].frequency:this.dummydata"
                                                #Frequency="ngModel" type="text" class="form-control"
                                                placeholder="Frequency" required>
                                        </div>
                                        <div class="mb-4 width position-relative">
                                            <label for="PremiumValue" class="form-label">Premium Value Inclusive of
                                                Taxes</label>


                                            <input readonly name="PremiumValue"
                                                [(ngModel)]="(this.isstatus === 'newCustomer' && originalPremiumAmt) ? originalPremiumAmt:(this.isstatus === 'existingCustomer' && this.userdata) ? premiumWithGST:this.dummydata "
                                                #premiumAmount="ngModel" type="number" class="form-control"
                                                placeholder="Premium Value" required>
                                            <!--new change-->
                                            <div class="mandateValue"
                                                [ngClass]="(isstatus !== 'existingCustomer' && (paymentType !== 'CCSI') && (paymentType !== 'ccsi')) ? 'position-relative' : ''">

                                                <p>Mandate value: {{(this.isstatus === 'newCustomer' && this.userdata) ?
                                                    this.userdata.stringval5:(this.isstatus === 'existingCustomer'
                                                    &&
                                                    this.userdata) ? this.userdata[0].final_amount :this.dummydata }}
                                                </p>

                                                <span>*Disclaimer: The mandate value is higher than the policy premium
                                                    value. The actual premium
                                                    amount may vary due to applicable taxes if any and other charges.
                                                    However, only the
                                                    actual premium amount will be deducted. </span>
                                            </div>
                                        </div>
                                        <!--New change-->


                                        <!-- <div class="row col-lg-12 col-md-12 col-sm-6 col-xs-12"
                                            *ngIf="isstatus === 'existingCustomer' && (paymentType !== 'CCSI') && (paymentType !== 'ccsi')">
                                            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12"
                                                *ngIf="(frequency !== 'Monthly') && (frequency !== '12')">
                                                <label class="radio-inline containerradio">
                                                    <input type="radio" name="type" checked="checked" value="SAME"
                                                        [(ngModel)]="userDateDetails.dateType" (change)="getValue('0')">
                                                    <span class="checkmark"></span>
                                                    Same Month as Due Date</label>
                                            </div>
                                            <div class="form-group col-lg-4 col-md-12 col-sm-12 col-xs-12"
                                                *ngIf="(frequency !== 'Monthly') && (frequency !== '12')">
                                                <label class="radio-inline containerradio">
                                                    <input type="radio" name="type" value="NEXT" id="id2"
                                                        [(ngModel)]="userDateDetails.dateType" (change)="getValue('1')">
                                                    <span class="checkmark"></span>
                                                    Next Month as Due Date</label>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mar-bot"
                                                style="top: -8px;">
                                                <div class="form-group form-inline">
                                                    <label class="labeltext" for="pwd">Select Preferred date :</label>
                                                    &nbsp;<span *ngIf="preferedDateList.length == 0">NA</span>
                                                    <select *ngIf="preferedDateList.length > 0" type="text"
                                                        class="form-control" name="frequency"
                                                        [(ngModel)]="userDateDetails.selectedPDate"
                                                        (change)="getDropdownValue()">
                                                        <option value="" disabled selected>Select </option>
                                                        <option [value]="item.month"
                                                            *ngFor="let item of preferedDateList">{{item.month}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="mb-4 width position-relative "
                                            *ngIf="isstatus === 'existingCustomer' && (paymentType !== 'CCSI') && (paymentType !== 'ccsi') ">

                                            <label for="preferreddate" class="form-label">Your Preferred Date <span
                                                    tooltip="If your preferred date is earlier than the due date, the premium will be debited on the preferred date, but the amount will be applied to the policy as per actual due date."><img
                                                        src="./assets/images/info-small.png"></span>
                                            </label>
                                            <!-- <span *ngIf="preferedDateList.length == 0">
                                                    
                                                    NA</span> -->
                                            <select *ngIf="preferedDateList.length == 0" name="preferreddate"
                                                class="form-select form-control" id="preferreddate">
                                                <option value="" disabled selected>N/A</option>
                                            </select>
                                            <select *ngIf="preferedDateList.length > 0" name="preferreddate"
                                                class="form-select form-control" id="preferreddate"
                                                [(ngModel)]="userDateDetails.selectedPDate">
                                                <option value="" disabled selected>Select Preferred Date</option>

                                                <option [value]="item.month" *ngFor="let item of preferedDateList">{{
                                                    item.month}}</option>
                                            </select>
                                            <span class="bgDrop"></span>
                                        </div>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div><!--Accodion Items-->

                    <!--Register Online Mandate-->
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <img src="./assets/images/003-portal.png" class="img-fluid">&nbsp;&nbsp; Register Online
                                Mandate
                            </button>
                            <!--Desktop step-3-->
                            <div class="stepCountRow disp-desktop">
                                <div class="content">
                                    <p class="heading">Register online mandate</p>
                                    <p class="text">Set the mode of transaction for online mandate registration</p>
                                </div>
                                <p class="stepCount disabled">3</p>
                            </div>
                        </h2>
                        <!-- End-->
                        <div id="collapseThree" class="accordion-collapse collapse" #collapseThree>
                            <div class="accordion-body" *ngIf="showAccodian3">
                                <!--new change-->
                                <div class="refNo">

                                    <p>Consumer Reference Noc:<span>{{displayNum}}</span>&nbsp;
                                        <button class="copy-btn " (click)="copyToClipboard(displayNum)">
                                            <i class="fa fa-copy"></i>
                                        </button>
                                    </p>
                                    <p>(Policy No/Application No/Unique Code)</p>
                                </div>

                                <div class="button-group mb-4">
                                    <!-- <div class="paymentOption"
                                        *ngIf="(isstatus === 'newCustomer') || (isstatus === 'existingCustomer' && (showEmandatePan))">
                                        <input class="form-check-input" type="radio" name="paymentOption"
                                            id="debitNetbanking" checked [(ngModel)]="selectedPaymentOption"
                                            value="debitNetbankingeMandate">
                                        <label class="form-check-label" for="debitNetbanking">
                                            Bank Account
                                        </label>
                                    </div> -->
                                    <div class="paymentOption"
                                        *ngIf="(isstatus === 'existingCustomer' && (showEnach) &&  (showEnachPan) && enableForVendor == 'TECHPROCESS') || (isstatus === 'newCustomer' && showEnach && enableForVendor == 'TECHPROCESS') || (isstatus === 'newCustomer' && enableForVendor == 'RAZORPAY') ">
                                        <input class="form-check-input" type="radio" name="paymentOption"
                                            id="debitNetbanking2" checked [(ngModel)]="selectedPaymentOption"
                                            value="debitNetbankingeNach">
                                        <label class="form-check-label" for="debitNetbanking2">
                                            Bank Account
                                        </label>
                                    </div>
                                    <div class="paymentOption" *ngIf="(showEnach) && enableForVendor == 'PAYGLOCAL'">
                                        <input class="form-check-input" type="radio" name="paymentOption" id="NachPGCL"
                                            [(ngModel)]="selectedPaymentOption" value="debitNetbankingeNach">
                                        <label class="form-check-label" for="NachPGCL">
                                            Bank Account
                                        </label>
                                    </div>

                                    <div class="paymentOption"
                                        *ngIf="((isstatus === 'newCustomer' && (activateUPIForNB) && (showUPIPan) ) || (isstatus === 'existingCustomer' && (showUPIPan) ) || (isstatus === 'newCustomer' && this.isChannel == 'agency' && (showUPIPan) )) && !(blockUPI)">
                                        <input class="form-check-input" type="radio" name="paymentOption" id="UPI"
                                            [(ngModel)]="selectedPaymentOption" value="UPI">
                                        <label class="form-check-label" for="UPI">
                                            UPI
                                        </label>
                                    </div>

                                    <!-- <div class="paymentOption"
                                       >
                                        <input class="form-check-input" type="radio" name="paymentOption" id="UPI"
                                            [(ngModel)]="selectedPaymentOption" value="UPI">
                                        <label class="form-check-label" for="UPI">
                                            UPI
                                        </label>
                                    </div>-->
                                    <!-- <div class="paymentOption"
                                        *ngIf=" (isstatus === 'newCustomer' && (activateUPIForNB) && (showUPIPan) && enableForUPIVendor == 'PAYGLOCAL' ) || (isstatus === 'existingCustomer' && (showUPIPan)  && enableForUPIVendor == 'PAYGLOCAL') || (isstatus === 'newCustomer' && this.isChannel == 'agency' && (showUPIPan)  && enableForUPIVendor == 'PAYGLOCAL') ">
                                        <input class="form-check-input" type="radio" name="paymentOption" id="UPIPGCL"
                                            [(ngModel)]="selectedPaymentOption" value="UPI">
                                        <label class="form-check-label" for="UPIPGCL">
                                            UPI 
                                        </label>
                                    </div>
                                    <div class="paymentOption"
                                        *ngIf="  (isstatus === 'newCustomer' && (activateUPIForNB) && (showUPIPan) && enableForUPIVendor == 'RAZORPAY') || (isstatus === 'existingCustomer' && (showUPIPan) && enableForUPIVendor == 'RAZORPAY') || (isstatus === 'newCustomer' && this.isChannel == 'agency' && (showUPIPan) && enableForUPIVendor == 'RAZORPAY')">
                                        <input class="form-check-input" type="radio" name="paymentOption" id="UPIRP"
                                            [(ngModel)]="selectedPaymentOption" value="UPI">
                                        <label class="form-check-label" for="UPIRP">
                                            UPI 
                                        </label>
                                    </div> -->

                                    <div class="paymentOption" *ngIf="showCCSIPan">
                                        <input class="form-check-input" type="radio" name="paymentOption"
                                            id="creditCard" [(ngModel)]="selectedPaymentOption"
                                            value="domesticcreditCard">
                                        <label class="form-check-label" for="creditCard">
                                            Domestic credit Card
                                        </label>
                                    </div>

                                    <div class="paymentOption" *ngIf="showCCSINRI">
                                        <input class="form-check-input" type="radio" name="paymentOption"
                                            id="internationalcreditCard" [(ngModel)]="selectedPaymentOption"
                                            value="internationalcreditCard">
                                        <label class="form-check-label" for="internationalcreditCard">
                                            International Credit Card
                                        </label>
                                    </div>

                                </div>

                                <!--New changes-->
                                <div class="accountDetails position-relative my-5" id="bankAccountDetails"
                                    *ngIf="isstatus === 'newCustomer' && (showPrefillOption) &&  selectedPaymentOption != 'UPI'  &&  selectedPaymentOption != 'domesticcreditCard'   &&   selectedPaymentOption != 'internationalcreditCard' ">
                                    <div
                                        class=" d-flex align-items-start justify-content-start flex-column flex-md-row gap-5">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="bankDetails"
                                                id="sameBank" checked [(ngModel)]="selectedRadioOption" value="yes">
                                            <label class="form-check-label" for="sameBank">
                                                Same Bank Details
                                            </label>
                                            <br>
                                            <div
                                                class="bankDetails d-flex align-items-center justify-content-between flex-column flex-md-row gap-1 gap-md-5">
                                                <p>Account no : <span>{{getAccountNo}}</span></p>
                                                <p>IFSC Code : <span>{{getIFSCNo}}</span></p>
                                            </div>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="bankDetails"
                                                id="otherBank" [(ngModel)]="selectedRadioOption" value="no">
                                            <label class="form-check-label" for="otherBank">
                                                Other Bank Details
                                            </label>
                                        </div>
                                    </div>

                                </div>




                                <div class="button-group UPI position-relative my-5 " id="UpiDetails"
                                    *ngIf="selectedPaymentOption === 'UPI' ">
                                    <a href="#"><img src="./assets/images/upi.png" class="img-fluid"></a>
                                </div>
                                <div class="button-group UPI position-relative my-5 " id="DomesticCardDetails"
                                    *ngIf="selectedPaymentOption === 'domesticcreditCard'">
                                    <a href="#"><img src="./assets/images/visa.png" class="img-fluid"></a>
                                    <a href="#"><img src="./assets/images/mastercard.png" class="img-fluid"></a>
                                    <a href="#"><img src="./assets/images/American_Express-Logo.png"
                                            class="img-fluid"></a>
                                </div>
                                <div class="button-group UPI position-relative my-5 " id="InternationalCardDetails"
                                    *ngIf="selectedPaymentOption === 'internationalcreditCard'">
                                    <a href="#"><img src="./assets/images/visa.png" class="img-fluid"></a>
                                    <a href="#"><img src="./assets/images/mastercard.png" class="img-fluid"></a>
                                    <a href="#"><img src="./assets/images/American_Express-Logo.png"
                                            class="img-fluid"></a>
                                </div>

                                <p class="disclaimer mt-5" *ngIf="selectedPaymentOption === 'debitNetbankingeNach'">
                                    Note: Keep your net banking login ID, password and registered mobile number handy.
                                    You will be redirected to the bank page for authorization. Click ‘Submit’ when
                                    ready.
                                </p>
                                <p class="disclaimer mt-5" *ngIf="selectedPaymentOption === 'UPI'">Note: Keep your UPI
                                    ID and registered mobile number handy.
                                    You will be redirected to the UPI page for authorization. Click ‘Submit’ when ready.
                                </p>
                                <p class="disclaimer mt-5"
                                    *ngIf="selectedPaymentOption === 'internationalcreditCard' || selectedPaymentOption === 'domesticcreditCard'">
                                    Note: Keep your card details and registered mobile number handy.
                                    You will be redirected to the bank page for authorization. Click ‘Submit’ when
                                    ready.
                                </p>
                                <div class="form-check disclaimer">
                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                        [(ngModel)]="isChecked">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        I declare that the mandate is being registered by me through a bank account in
                                        my name or a Credit/Debit Card or through a Prepaid Payment Instrument (Wallet),
                                        held by me in my name as a primary holder and is not a third party account by
                                        any other person on my behalf.
                                    </label>
                                </div>
                                <div class="formGroup my-5">
                                    <button type="submit" class="btn btn-orange" (click)="onProceed()"
                                        [disabled]="!isChecked">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div><!--Accordion Emandate-->
                </div>
            </div>
        </section>
        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <form (ngSubmit)="instabForm.form.valid && submitinstabFormData(template)" #instabForm="ngForm">
                    <div class="modal-content">
                        <div class="modal-header border border-0">
                            <!-- <h1 class="modal-title fs-5" id="exampleModalLabel">Unique Code: 344166</h1> -->
                            <button #instabmodal type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body px-md-5">
                            <h4 class="text-center mb-5">Without Application No. Registration <span>(Only for Instab &
                                    Digi)</span>
                            </h4>
                            <div class="row gy-5" style="margin-left: 0;">
                                <!--new change-->
                                <div class="col-md-6 col-sm-6 col-12">
                                    <label for="UniqueCode" class="form-label">Unique Code</label>
                                    <input type="text" class="form-control" id="UniqueCode"
                                        placeholder="Enter Unique Code" readonly [(ngModel)]="uniqueId"
                                        name="uniquecode">
                                </div>
                                <div class="col-md-6 col-sm-6 col-12">
                                    <label for="PolicyHolderModal" class="form-label">Policyholder Name (As per Bank
                                        records)</label>

                                    <input name="PolicyHolder"
                                        [ngClass]="{ 'is-invalid': instabForm.submitted && PolicyHolderModal.invalid }"
                                        [(ngModel)]="instabFormData.PolicyHolderModal" #PolicyHolderModal="ngModel"
                                        type="text" class="form-control" placeholder="Policy Holder" required>
                                </div>
                                <div class="col-md-6 col-sm-6 col-12 date position-relative">
                                    <label for="dateIDModal" class="form-label">Date of Birth of Policy
                                        Holder</label>

                                    <input class="form-control" bsDatepicker placeholder="DD/MM/YYYY" name="dateIDModal"
                                        [outsideClick]="true" #dateIDModal="ngModel"
                                        [(ngModel)]="instabFormData.dateIDModal"
                                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', isAnimated: true }"
                                        [ngClass]="{ 'is-invalid': instabForm.submitted && dateIDModal.invalid }"
                                        required>
                                    <span class="bgImg" style="right: 25px;"></span>
                                </div>
                                <div class="col-md-6 col-sm-6 col-12">
                                    <label for="PremiumValueInclusive" class="form-label">Premium Value Inclusive of
                                        Taxes</label>
                                    <!-- 
                                        <input type="number" class="form-control" id="PremiumValueInclusive"
                                        #PremiumValueInclusive="ngModel" placeholder="Enter Premium Value"
                                        [(ngModel)]="instabFormData.PremiumValueInclusive"
                                        [ngModelOptions]="{standalone: true}" min="1"
                                        [ngClass]="{ 'is-invalid': instabForm.submitted && PremiumValueInclusive.invalid }"
                                        required> -->
                                    <input type="text" class="form-control" id="PremiumValueInclusive"
                                        #PremiumValueInclusive="ngModel" placeholder="Enter Premium Value"
                                        [(ngModel)]="instabFormData.PremiumValueInclusive"
                                        [ngModelOptions]="{standalone: true}" min="1"
                                        [ngClass]="{ 'is-invalid': instabForm.submitted && PremiumValueInclusive.invalid }"
                                        (keyup)="checkPremiumValueInclusive($event)" required>
                                </div>
                                <!-- <div class="col-md-6 col-sm-6 col-12">
                                    <label for="FrequencyModal" class="form-label">Frequency</label>
                                    <select class="form-select form-control" id="FrequencyModal"
                                        aria-label="Default select example" [(ngModel)]="instabFormData.FrequencyModal"
                                        #FrequencyModal="ngModel" [ngModelOptions]="{standalone: true}"
                                        [ngClass]="{ 'is-invalid': instabForm.submitted && FrequencyModal.invalid }"
                                        required>
                                        <option disabled selected>Select Frequency</option>
                                        <option value="Monthly">Monthly</option>
                                        <option value="Quarterly">Quarterly</option>
                                        <option value="Half-Yearly">Half-Yearly</option>
                                        <option value="Yearly">Annualy</option>
                                    </select>
                                </div> -->

                                <div class="col-md-6 col-sm-6 col-12">
                                    <label for="FrequencyModal" class="form-label">Frequency</label>
                                    <div
                                        class=" d-flex align-items-start justify-content-start flex-column flex-md-row gap-5">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="frequencyDtls"
                                                id="Monthly" checked value="Monthly"
                                                [(ngModel)]="instabFormData.FrequencyModal"
                                                [ngModelOptions]="{standalone: true}" checked>
                                            <label class="form-check-label" for="Monthly">
                                                Monthly
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="frequencyDtls"
                                                id="Quarterly" value="Quarterly"
                                                [(ngModel)]="instabFormData.FrequencyModal"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label" for="Quarterly">
                                                Quarterly
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="frequencyDtls"
                                                id="Half-Yearly" value="Half-Yearly"
                                                [(ngModel)]="instabFormData.FrequencyModal"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label" for="Half-Yearly">
                                                Half-Yearly
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="frequencyDtls"
                                                id="Yearly" value="Yearly" [(ngModel)]="instabFormData.FrequencyModal"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label" for="Yearly">
                                                Annualy
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer border border-0 my-5">
                            <button type="submit" class="btn btn-orange m-auto">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>




</body>
<!-- templates used  -->

<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title pull-left" style="color:black"><b>Error</b></h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <!-- {{errorMessage}} -->
        <div class=" modal-body error" style="text-align: center; color: red; font-size: 24px;">{{errorMessage}}</div>
    </div>
</ng-template>




<ng-template #template1>

    <div class="modal-body text-center">
        <p style="text-align: center; color: red; font-size: 19px;">Autopay facility is already active for your policy.
            Please click on proceed to update your Autopay details.</p>
        <button type="button" class="btn btn-success" id="proceed" (click)="confirm()">Proceed</button> &nbsp;&nbsp;
        <button type="button" class="btn btn-primary" (click)="decline()">Cancel</button>
    </div>
</ng-template>

<ng-template #template2>
    <div class="modal-header">
        <h4 class="modal-title pull-left" style="color:black"><b>Alert</b></h4>

    </div>
    <div class="modal-body">
        <!-- {{errorMessage}} -->
        <div style="text-align: center; font-size: 24px;">To proceed with mandate registration, please click to proceed
        </div>
    </div>
    <div class="modal-footer">
    </div>
</ng-template>
<ng-template #template3>

    <div class="modal-body text-center">
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef3.hide()"><span
                aria-hidden="true">&times;</span></button>
        <p style="text-align: center; color: red; font-size: 19px;">Please enter valid application number.</p>
    </div>
</ng-template>

<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title pull-left" style="color:black"><b>Error</b></h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef1.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <!-- {{errorMessage}} -->
        <div class=" modal-body error" style="text-align: center; color: red; font-size: 24px;">{{errorMessage}}</div>
    </div>
</ng-template>

<ng-template #templet2>
    <div class="" id="requestSentModal" tabindex="-1" aria-hidden="true">
        <div class="modal-header">
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef2.hide()">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div *ngIf="desableForDwontime">
                        <div *ngFor="let item of downTimeData">
                            <b class="text-danger" *ngIf="item.downtime_TYPE == 'ALERT'">{{item.downtime_MESSAGE}}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- forms used-->


<!--implement of  Domestic  CCSI -->
<div hidden>
    <form *ngIf="isstatus === 'newCustomer' && (showCCSIPan)" ngNoForm action={{ccsi}} id="newCustCCSI"
        name="newCustCcsifrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameuext" name="moduleName" value="OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderccsinew" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountccsinew" name="totalAmount" value="">
        <input type="hidden" id="consumerIdccsinew" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoccsinew" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdccsinew" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateccsinew" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateccsinew" name="debitEndDate" value="">
        <input type="hidden" id="frequencyccsinew" name="frequency" value="">
        <button type="submit" id="ccsipan" class="btn btn-success" (click)="sendDataCredit()" #ccsinewcustbtn
            class="clickhere">click
            here</button>

    </form>

    <!-- for existing -->
    <form *ngIf="isstatus === 'existingCustomer' && (showCCSIPan)" ngNoForm action={{ccsi}} id="exiCustCCSI"
        name="exiCustCcsifrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameuext" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderccsiexi" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountccsiexi" name="totalAmount" value="">
        <input type="hidden" id="consumerIdccsiexi" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoccsiexi" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdccsiexi" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateccsiexi" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateccsiexi" name="debitEndDate" value="">
        <input type="hidden" id="frequencyccsiexi" name="frequency" value="">

        <button type="submit" id="ccsipan" class="btn btn-success" (click)="submitDatacreditexsting()" #ccsiextcustbtn
            class="clickhere">click
            here</button>
    </form>
</div>

<!--implement of  Domestic  CCSI End -->

<!-- Emandate-->
<div hidden>
    <!--Emandate OPUS starts-->
    <form *ngIf="isstatus === 'newCustomer'" ngNoForm action={{emandate}} id="newCustEmandate" name="newCustEmandateFrm"
        target="_blank" method="post">
        <input type="hidden" id="moduleName1" name="moduleName" value="OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderName1" name="policyHolderName" value="">
        <input type="hidden" id="totalAmount1" name="totalAmount" value="">
        <input type="hidden" id="consumerId1" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNo1" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailId1" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDate1" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDate1" name="debitEndDate" value="">
        <input type="hidden" id="maxAmount1" name="maxAmount" value="">
        <input type="hidden" id="amountType1" name="amountType" value="">
        <input type="hidden" id="frequency1" name="frequency" value="">
        <input type="hidden" id="renewalID1" name="moduleName" value="">
        <input type="hidden" id="payableAmount1" name="payableAmount" value="">
        <input type="hidden" id="staticEmandate1" name="staticEmandate" value="staticEmandate">

        <!-- additional fields for emandate  -->
        <input type="hidden" id="takeAccountNo1" name="takeAccountNo" value="">
        <input type="hidden" id="takeIFSCCode1" name="takeIFSCCode" value="">


        <button type="submit" class="clickhere" id="first" #netbankemandatenewcust (click)="sendData()">click
            here</button>
    </form>

    <!-- for emandate existing cust -->
    <form *ngIf="isstatus === 'existingCustomer' && (showEmandatePan)" ngNoForm action={{emandate}}
        id="existCustEmandate" name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleName1" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameexeman" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountexeman" name="totalAmount" value="">
        <input type="hidden" id="consumerIdexeman" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoexeman" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdexeman" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateexeman" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateexeman" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountexeman" name="maxAmount" value="">
        <input type="hidden" id="amountTypeexeman" name="amountType" value="">
        <input type="hidden" id="frequencyexeman" name="frequency" value="">
        <input type="hidden" id="moduleIdexeman" name="moduleName" value="">
        <input type="hidden" id="renewalIDexeman" name="renewalID" value="">
        <input type="hidden" id="payableAmountexeman" name="payableAmount" value="">
        <input type="hidden" id="prefdateeman" name="prefDate" value="">
        <input type="hidden" id="preftypeeman" name="prefType" value="">

        <button type="submit" id="first" class="btn btn-success" #netbankemandateextcust (click)="submitDataeme()"
            class="clickhere">click
            here</button>
    </form>
    <!--Emandate OPUS ends-->
    <!--Emandate NGIN starts-->
    <form *ngIf="isstatus === 'existingCustomer' && (showEmandatePan)" ngNoForm action={{emandate}}
        id="existCustEmandate" name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleName1" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameexeman" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountexeman" name="totalAmount" value="">
        <input type="hidden" id="consumerIdexeman" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoexeman" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdexeman" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateexeman" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateexeman" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountexeman" name="maxAmount" value="">
        <input type="hidden" id="amountTypeexeman" name="amountType" value="">
        <input type="hidden" id="frequencyexeman" name="frequency" value="">
        <input type="hidden" id="moduleIdexeman" name="moduleName" value="">
        <input type="hidden" id="renewalIDexeman" name="renewalID" value="">
        <input type="hidden" id="payableAmountexeman" name="payableAmount" value="">
        <input type="hidden" id="prefdateeman" name="prefDate" value="">
        <input type="hidden" id="preftypeeman" name="prefType" value="">
        <input type="hidden" id="subModuleeman" name="p_si_sub_module" value="">

        <button type="submit" id="first" class="btn btn-success" #netbankemandateextcust_ngin
            (click)="submitDataeme_NGIN()" class="clickhere">click
            here</button>
    </form>
    <!--Emandate NGIN ends-->
</div>

<!--Emandate end-->



<!--Enach starts-->
<div hidden>

    <!--Opus starts-->
    <form *ngIf="isstatus === 'existingCustomer' && (showEnach) &&  (showEnachPan)" ngNoForm action={{enach}}
        id="existCustEmandate" name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameenach" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameenach" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountenach" name="totalAmount" value="">
        <input type="hidden" id="consumerIdenach" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoenach" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdenach" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateenach" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateenach" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountenach" name="maxAmount" value="">
        <input type="hidden" id="amountTypeenach" name="amountType" value="">
        <input type="hidden" id="frequencyenach" name="frequency" value="">
        <input type="hidden" id="prefdate" name="prefDate" value="">
        <input type="hidden" id="preftype" name="prefType" value="">
        <input type="hidden" id="subModuleenach" name="p_si_sub_module" value="">
        <button type="submit" class="btn btn-success" #netbankenachextcust (click)="sendDataForEnachExistingCust()"
            class="clickhere" id="enachpan">click here</button>
    </form>

    <form *ngIf="isstatus === 'newCustomer' && showEnach && enableForVendor == 'TECHPROCESS'" ngNoForm action={{enach}}
        id="existCustEmandate" name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameenach" name="moduleName" value="INSTAB|OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderNameenach" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountenach" name="totalAmount" value="">
        <input type="hidden" id="consumerIdenach" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoenach" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdenach" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateenach" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateenach" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountenach" name="maxAmount" value="">
        <input type="hidden" id="amountTypeenach" name="amountType" value="">
        <input type="hidden" id="frequencyenach" name="frequency" value="">
        <input type="hidden" id="staticEmandateenach" name="staticEmandate" value="staticEmandate">

        <!-- additional fields for emandate  -->
        <input type="hidden" id="takeAccountNoenatch" name="takeAccountNo" value="">
        <input type="hidden" id="takeIFSCCodeenatch" name="takeIFSCCode" value="">

        <button type="submit" id="enachpan" class="btn btn-success" #netbankenachnewcust
            (click)="sendDataForEnachNewCust()" class="clickhere">click
            here</button>
    </form>
    <!--Opus Ends-->

    <!--Ngin starts-->
    <form *ngIf="isstatus === 'newCustomer' && showEnach" ngNoForm action={{enach}} id="existCustEmandate"
        name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameenach_nb_ngin" name="moduleName" value="INSTAB|OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderNameenach_nb_ngin" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountenach_nb_ngin" name="totalAmount" value="">
        <input type="hidden" id="consumerIdenach_nb_ngin" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoenach_nb_ngin" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdenach_nb_ngin" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateenach_nb_ngin" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateenach_nb_ngin" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountenach_nb_ngin" name="maxAmount" value="">
        <input type="hidden" id="amountTypeenach_nb_ngin" name="amountType" value="">
        <input type="hidden" id="frequencyenach_nb_ngin" name="frequency" value="">

        <div class="clearfix"></div>

        <button type="submit" class="btn btn-success" #netbankenachnewcust_ngin (click)="sendDataForEnachNewCust_NGIN()"
            class="clickhere">click
            here</button>
    </form>

    <form *ngIf="isstatus === 'existingCustomer' && (showEnach) &&  (showEnachPan)" ngNoForm action={{enach}}
        id="existCustEmandate" name="existCustEmandatefrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameenach_ngin" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameenach_ngin" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountenach_ngin" name="totalAmount" value="">
        <input type="hidden" id="consumerIdenach_ngin" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoenach_ngin" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdenach_ngin" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateenach_ngin" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateenach_ngin" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountenach_ngin" name="maxAmount" value="">
        <input type="hidden" id="amountTypeenach_ngin" name="amountType" value="">
        <input type="hidden" id="frequencyenach_ngin" name="frequency" value="">
        <input type="hidden" id="prefdate_ngin" name="prefDate" value="">
        <input type="hidden" id="preftype_ngin" name="prefType" value="">
        <input type="hidden" id="subModuleenach_ngin" name="p_si_sub_module" value="">
        <div class="clearfix"></div>

        <button type="submit" class="btn btn-success" #netbankenachextcust_ngin
            (click)="sendDataForEnachExistingCust_NGIN()" class="clickhere">click
            here</button>
    </form>
    <!--Ngin ends-->
</div>
<!--Enach ends-->

<!--UPI starts-->
<div hidden>
    <!--Opus starts-->
    <form *ngIf="isstatus === 'newCustomer' && (activateUPIForNB) && (showUPIPan)" ngNoForm action={{upiManUrl}}
        id="newCustUpi" name="newCustUpiFrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameu" name="moduleName" value="OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderNameu" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountu" name="totalAmount" value="">
        <input type="hidden" id="consumerIdu" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNou" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdu" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateu" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateu" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountu" name="maxAmount" value="">
        <input type="hidden" id="amountTypeu" name="amountType" value="">
        <input type="hidden" id="frequencyu" name="frequency" value="">
        <input type="hidden" id="renewalIDu" name="moduleName" value="">
        <input type="hidden" id="payableAmountu" name="payableAmount" value="">
        <button type="submit" class="btn btn-success" #upinewcust (click)="sendUPIDataNewCust()">click here</button>
    </form>


    <form *ngIf="isstatus === 'existingCustomer' && (showUPIPan)" ngNoForm action={{upiManUrl}} id="existCustUpi"
        name="existCustUpifrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameuext" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameuext" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountuext" name="totalAmount" value="">
        <input type="hidden" id="consumerIduext" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNouext" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIduext" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateuext" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateuext" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountuext" name="maxAmount" value="">
        <input type="hidden" id="amountTypeuext" name="amountType" value="">
        <input type="hidden" id="frequencyuext" name="frequency" value="">
        <input type="hidden" id="moduleIdeuext" name="moduleName" value="">
        <input type="hidden" id="renewalIDuext" name="renewalID" value="">
        <input type="hidden" id="payableAmountuext" name="payableAmount" value="">
        <input type="hidden" id="prefdateuext" name="prefDate" value="">
        <input type="hidden" id="preftypeuext" name="prefType" value="">
        <button type="submit" class="btn btn-success" id="btnupi" #upiextcust (click)="sendUPIDataOldCust()"
            class="clickhere">click
            here</button>
    </form>
    <!--Opus ends-->
    <!--NGIN starts-->

    <form *ngIf="isstatus === 'existingCustomer' && (showUPIPan)" ngNoForm action={{upiManUrl}} id="existCustUpi"
        name="existCustUpifrm" target="_blank" method="post">
        <input type="hidden" id="moduleNameuext" name="moduleName" value="OPEN_LINK_EXISTING">
        <input type="hidden" id="policyHolderNameuext" name="policyHolderName" value="">
        <input type="hidden" id="totalAmountuext" name="totalAmount" value="">
        <input type="hidden" id="consumerIduext" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNouext" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIduext" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDateuext" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDateuext" name="debitEndDate" value="">
        <input type="hidden" id="maxAmountuext" name="maxAmount" value="">
        <input type="hidden" id="amountTypeuext" name="amountType" value="">
        <input type="hidden" id="frequencyuext" name="frequency" value="">
        <input type="hidden" id="moduleIdeuext" name="moduleName" value="">
        <input type="hidden" id="renewalIDuext" name="renewalID" value="">
        <input type="hidden" id="payableAmountuext" name="payableAmount" value="">
        <input type="hidden" id="prefdateuext" name="prefDate" value="">
        <input type="hidden" id="preftypeuext" name="prefType" value="">
        <input type="hidden" id="subModuleeman" name="p_si_sub_module" value="">

        <div class="clearfix"></div>
        <button type="submit" class="btn btn-success" id="btnupi" #upiextcust_ngin (click)="sendUPIDataOldCust_NGIN()"
            class="clickhere">click
            here</button>
    </form>
    <!--NGIN ends-->

    <!-- upi m -->
    <!-- <form *ngIf="isstatus === 'newCustomer' && this.isChannel == 'agency' && (showUPIPan)" ngNoForm action={{upiManUrl}}
        id="instabCustUpi" name="instabCustUpiFrm" target="_blank" method="post">
        <input type="hidden" id="moduleNamei" name="moduleName" value="OPEN_LINK_NEW">
        <input type="hidden" id="policyHolderNamei" name="policyHolderName" value="">
        <input type="hidden" id="totalAmounti" name="totalAmount" value="">
        <input type="hidden" id="consumerIdi" name="consumerId" value="">
        <input type="hidden" id="consumerMobileNoi" name="consumerMobileNo" value="">
        <input type="hidden" id="consumerEmailIdi" name="consumerEmailId" value="">
        <input type="hidden" id="debitStartDatei" name="debitStartDate" value="">
        <input type="hidden" id="debitEndDatei" name="debitEndDate" value="">
        <input type="hidden" id="maxAmounti" name="maxAmount" value="">
        <input type="hidden" id="amountTypei" name="amountType" value="">
        <input type="hidden" id="frequencyi" name="frequency" value="">
        <input type="hidden" id="renewalIDi" name="moduleName" value="">
        <input type="hidden" id="payableAmounti" name="payableAmount" value="">
        <button type="submit" class="btn btn-success" #upiinstabcust (click)="sendUPIDataInstabCust()">click
            here</button>
    </form> -->
</div>
<!--UPI ends-->